import request from "../utils/request";
// Отправка на модерацию /api/company-objects/daily-polution-emissions/ dailyPollutionEmissions

// csak dashboard
export function getAllStatisticDashbord(params) {
  return request({
    url: "/api/company-objects/count-companies-region/",
    method: "get",
    params,
    responseType: params.excel ? "blob" : "json"
  });
}

// csak dashboard

//  в модерации для группового удаления или смены статуса

export function changeStatusGroupEmission(data) {
  return request({
    url: "/api/company-objects/emission-status-bulk-change/",
    method: "put",
    data
  });
}

export function deleteGroupEmission(data) {
  return request({
    url: "/api/company-objects/emission-bulk-delete/",
    method: "delete",
    data
  });
}

//  в модерации для группового удаления или смены статуса

export function getCart(params) {
  // Получение отчетов по источнику и компоненту { source_id : (int) , component_id: (int)}
  return request({
    url: "/api/company-objects/get-emissions_cart/",
    method: "get",
    params
  });
}

export function getObjectDailyPollutionEmissions(data) {
  // Получение отчетов по источнику и компоненту { source_id : (int) , component_id: (int)}
  return request({
    url: "/api/company-objects/daily-polution-emissions/",
    method: "get",
    params: data
  });
}

export function addObjectDailyPollutionEmissions(data) {
  return request({
    url: "/api/company-objects/store-source-components-emissions/",
    method: "post",
    data
  });
}

export function editObjectDailyPollutionEmissions(data) {
  return request({
    url: "/api/company-objects/daily-polution-emissions/",
    method: "put",
    data
  });
}

export function deleteObjectDailyPollutionEmissions(data) {
  // удаление занесенных данных из бэка по id
  return request({
    url: "/api/company-objects/daily-polution-emissions/",
    method: "delete",
    data
  });
}

export function getObjectDailyPollutionEmissionsWithFilter(data) {
  // Получение отчетов по фильтру
  return request({
    url: "/api/company-objects/get-emissions/",
    method: "get",
    params: data,
    responseType: data.excel ? "blob" : "json",
    timeout: 0
    /*
        filters -> (status_id, ecology_type_id,region_id,start_date,end_date)
        poisk -> (search (string))
        pagination (page, page_size)
        {
          status_id: int
          ecology_type_id: int
          region_id: int
          start_date: YYYY-MM-DD
          end_date: YYYY-MM-DD
          *
        }
    */
  });
}

export function getAllStatusesEmissions(params) {
  // Возвращает список всех статусов
  return request({
    url: "/api/company-objects/get-emission-statuses/",
    method: "get",
    params
  });
}

export function changeEmissionStatus(data) {
  // Изменнение статуса определенного отсета с коментарием(не обязательный)
  return request({
    url: "/api/company-objects/change-emission-statuses/",
    method: "post",
    data
    /*{id (integer → emission id)(required) ,
        status_id (integer) (required) ,
        description ---> (text ) (not required)  }

        {
          id: int,
          status_id: int,
          description: string  (not required)
        }*/
  });
}

export function getDashboardData(params) {
  // Получение всех комментариев у занесенных данных у определенного эмишина (emission)
  // GET ---->>> ?daily_emission_id=11
  return request({
    url: "/api/company-objects/get-emissions_success_data_count/",
    method: "get",
    params,
  });
}

export function getCommentsDailyPollutionEmissions(data) {
  // Получение всех комментариев у занесенных данных у определенного эмишина (emission)
  // GET ---->>> ?daily_emission_id=11
  return request({
    url: "/api/company-objects/daily-emission-comments/",
    method: "get",
    params: data
  });
}

export function addCommentsDailyPollutionEmissions(data) {
  // Добавление комментария занесенных данных у определенного эмишина (emission)
  // POST ---->>> daily_emission_id(int)[required] , parent_id(int)[not required] , comment_text(string)
  return request({
    url: "/api/company-objects/daily-emission-comments/",
    method: "post",
    data: data
  });
}

export function deleteCommentsDailyPollutionEmissions(data) {
  // Удаление комментария занесенных данных у определенного эмишина (emission)
  // DELETE ---->>> comment_id
  return request({
    url: "/api/company-objects/daily-emission-comments/",
    method: "delete",
    data: data
  });
}
